import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronLargeDown"><Path fillRule="evenodd" clipRule="evenodd" d="M2.61142 8.64062L11.9999 13.8565L21.3885 8.64062L22.3597 10.3889L11.9999 16.1444L1.64014 10.3889L2.61142 8.64062Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLargeDown;
